import {Animated, Dimensions} from "react-native"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import CommandsPool from "@kaspernj/api-maker/build/commands-pool"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import {SchoolClass} from "models"
import setLayout from "shared/set-layout"
import useEventListener from "ya-use-event-listener"
import usePressOutsideProps from "outside-eye/build/use-press-outside-props.js"

/**
 * @typedef {object} ComponentsLayoutBaseProps
 * @property {unknown} children
 * @property {unknown} className
 * @property {unknown} dataSet
 * @property {string} headerTitle
 * @property {string} headTitle
 * @property {string} layout
 * @property {SchoolClass} schoolClass
 * @property {unknown} style
 */

/** @typedef {object} ComponentsLayoutBaseState */

/**
 * @extends {ShapeComponent<ComponentsLayoutBaseProps, ComponentsLayoutBaseState>}
 */
class ComponentsLayoutBase extends ShapeComponent {
  static defaultProps = {
    layout: "front",
    schoolClass: null
  }

  static propTypes = {
    headTitle: PropTypes.string,
    headerTitle: PropTypes.string,
    schoolClass: PropTypes.instanceOf(SchoolClass)
  }

  windowHeight = new Animated.Value(Dimensions.get("window").height)

  setup() {
    useMemo(() => {
      this.setGlobalRequestDataLayout()
    }, [])

    useMemo(() => {
      this.setDocumentTitle()
    }, [this.props.headTitle, this.props.headerTitle])

    useMemo(() => {
      this.setSchoolAndClass()
    }, [this.p.schoolClass?.id()])

    useEventListener(Dimensions, "change", this.tt.onDimensionsChange)
  }

  componentWillUnmount() {
    CommandsPool.current().globalRequestData.school_id = undefined
    CommandsPool.current().globalRequestData.school_class_id = undefined
  }

  setDocumentTitle() {
    const headTitle = this.props.headTitle || this.props.headerTitle

    if (headTitle) {
      document.title = headTitle
    } else {
      document.title = "WOOF"
    }
  }

  setGlobalRequestDataLayout() {
    if (!CommandsPool.current().globalRequestData) CommandsPool.current().globalRequestData = {}

    setLayout(this.p.layout)
  }

  setSchoolAndClass() {
    CommandsPool.current().globalRequestData.school_id = this.p.schoolClass?.schoolId()
    CommandsPool.current().globalRequestData.school_class_id = this.p.schoolClass?.id()
  }

  render() {
    const {children, className, dataSet, headTitle, headerTitle, layout, schoolClass, style, ...restProps} = this.props
    const actualStyle = Object.assign(
      {flex: 1, height: this.tt.windowHeight},
      style
    )
    const actualDataSet = Object.assign(
      {class: className, component: "layout/base", layout},
      dataSet
    )

    const pressOutsideProps = usePressOutsideProps(restProps)

    return (
      <Animated.View dataSet={actualDataSet} style={actualStyle} testID="baseLayoutView" {...pressOutsideProps}>
        {children}
      </Animated.View>
    )
  }

  onDimensionsChange = ({window}) => {
    this.windowHeight.setValue(window.height)
  }
}

export default memo(shapeComponent(ComponentsLayoutBase))
